
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TimeService from "@/services/TimeService";
import Restaurant from "@/domain/restaurant/Restaurant";
import RemoteServices from "@/services/RemoteServices";

@Component
export default class BookingViewDatePicker extends Vue {
  @Prop({ default: () => TimeService.getDateAtStartOfDay() })
  selectedDate!: Date;

  datePickerDialog = false;

  datePickerDate = "";

  pickerDateSync = TimeService.getISODateString(this.selectedDate);

  datesWithBookings: Set<string> = new Set<string>();

  loadingDatesWithBookings = false;

  datesWithBookingsTimeout = false;

  setDatesWithBookingsTimeout() {
    this.datesWithBookingsTimeout = true;
    setTimeout(this.resetDatesWithBookingsTimeout, 2000);
  }

  resetDatesWithBookingsTimeout() {
    this.datesWithBookingsTimeout = false;
  }

  mounted() {
    this.assertIsOpen(this.selectedDate);
    this.getDatesWithBookingsInMonth();
  }

  get datesWithBookingsArray(): string[] {
    return Array.from(this.datesWithBookings);
  }

  async getDatesWithBookingsInMonth() {
    this.loadingDatesWithBookings = true;
    const date = new Date(this.pickerDateSync);
    if (this.selectedRestaurant != null && this.pickerDateSync !== "") {
      const newDates = await RemoteServices.getDatesWithBookingsInMonth(
        date,
        this.selectedRestaurant
      );
      for (let i = 0; i < newDates.length; i++)
        this.datesWithBookings.add(newDates[i]);
      this.setDatesWithBookingsTimeout();
      if (newDates.length === 0)
        await this.$store.dispatch("warning", this.$t("booking.month.none"));
    }

    this.loadingDatesWithBookings = false;
  }

  showDatePickerDialog() {
    this.datePickerDate = TimeService.getISODateString(this.selectedDate);
    this.datePickerDialog = true;
  }

  closeDatePickerDialog() {
    this.datePickerDialog = false;
    const newDate = TimeService.setDateToStartOfDay(
      new Date(this.datePickerDate)
    );
    if (!TimeService.dateTimesEqual(this.selectedDate, newDate)) {
      this.updateDate(newDate);
    }
  }

  get selectedRestaurant(): Restaurant | null {
    return this.$store.getters.getSelectedRestaurant;
  }

  isClosedOnDate(dateString: string): boolean {
    return (
      this.selectedRestaurant != null &&
      !Restaurant.isOpenOnDate(this.selectedRestaurant, new Date(dateString))
    );
  }

  pickerEvents(dateString: string) {
    const colours = [];
    if (this.isClosedOnDate(dateString)) colours.push("red");
    if (this.datesWithBookings.has(dateString)) colours.push("blue");
    return colours;
  }

  getReasonIsClosed(date: Date): string {
    if (this.selectedRestaurant != null)
      return Restaurant.getReasonIsClosedOnDate(this.selectedRestaurant, date);
    return "No restaurant Selected : Closed on day";
  }

  get dateDisplayString() {
    return TimeService.getDateDisplayStringWithWeekDay(this.selectedDate);
  }

  assertIsOpen(date: Date) {
    if (this.isClosedOnDate(TimeService.getISODateString(date)))
      this.$store.dispatch("warning", this.getReasonIsClosed(date));
  }

  plusDay() {
    this.updateDate(TimeService.addDaysToDate(this.selectedDate, 1));
  }

  minusDay() {
    this.updateDate(TimeService.addDaysToDate(this.selectedDate, -1));
  }

  async updateDate(newDate: Date) {
    this.assertIsOpen(newDate);
    TimeService.setDateToStartOfDay(newDate);
    this.$emit("update-date", newDate);
  }

  @Watch("selectedRestaurant")
  reset() {
    this.datesWithBookings = new Set<string>();
    this.getDatesWithBookingsInMonth();
  }
}
